/* eslint-disable @typescript-eslint/naming-convention */
export interface MaintenanceConfigData {
	maintenance: boolean;
	banner: boolean;
	startAt: string;
	endAt: string;
	message: string;
}

export interface OrgData {
	isOrgSelected: boolean;
	orgName: string;
	orgId: string;
	orgNumber?: string;
}
export interface OrganizationsDto {
	description: string;
	name: string;
	number: string;
}
export interface OrganizationsResponse {
	createdOn: string;
	id: string;
	orgId: string;
	data: OrganizationsDto;
	status: string;
	default?: boolean;
	invitationToken: string;
}

export enum OrganizationInviteStatus {
	InviteSent = 'INVITE_SENT',
	InviteAccepted = 'INVITE_ACCEPTED',
	InviteRejected = 'INVITE_REJECTED',
	InviteRevoked = 'INVITE_REVOKED',
	UserExpired = 'USER_EXPIRED'
}

export interface DefaultOrgData {
	orgName: string;
	orgId: string;
}
export enum VerificationStatus {
	REQUESTED = 'REQUESTED',
	VERIFIED = 'VERIFIED',
	NONVERIFIED = 'NON-VERIFIED'
}

export interface AccountInformationDto {
	companyName?: string;
	department?: string;
	email?: string;
	emailPreferences?: {
		louderMusician?: boolean;
		louderContentCreator?: boolean;
		trainingCommunication?: boolean;
		marketingCommunication?: boolean;
	};
	firstName?: string;
	interests?: Array<string>;
	displayName?: string;
	jobTitle?: string;
	lastName?: string;
	mobilePhone?: string;
	isMobileVerified?: boolean;
	optOutOfEmail?: boolean;
	organizationDetails?: OrganizationDetails;
	preferences?: {
		language?: string;
		dateFormat?: string;
		region?: string;
		timeZone?: string;
		orderOfNames?: Array<string>;
	};
	profileImage?: {
		upload?: {
			fields?: object;
			url?: string;
		};
		get?: string;
	};
	relationToShure?: Array<string>;
	segment?: string;
	segmentDetails?: string;
	tc?: {
		isTcAccepted?: boolean;
		tcAcceptedAt?: string;
	};
	dataTransferConsent?: {
		isDataTransferConsented?: boolean;
	};
	workPhone?: string;
}

export interface OrganizationDetails {
	accountNumber?: string;
	companyName?: string;
	organizationName?: string;
	verificationStatus?: 'VERIFIED' | 'REQUESTED' | 'NON-VERIFIED';
	verifiedAt?: string;
}

export const mapOktaLanguageCode: Record<string, string> = {
	en_US: 'en',
	de_DE: 'de',
	ja_JP: 'ja',
	zh_CN: 'zh-cn',
	fr_FR: 'fr',
	es_ES: 'es',
	pt_BR: 'pt',
	ko_KR: 'ko'
};
